import { Block } from '@attom';

export const Form = ({
	children,
	// box Control
	boxClass = '',
	boxSize = '',
	boxSpace = '',
	...props
}) => {
	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace}>
			<form onSubmit={(e) => e.preventDefault()} {...props}>
				{children}
			</form>
		</Block>
	);
};
